import { Unit } from "../types"

export enum CycleStatus {
	New = "New",
	Rejected = "Rejected",
	RequireMoreInformation = "RequireMoreInformation",
	AwaitingAssurance = "AwaitingAssurance",
	Assured = "Assured",
	Failed = "Failed",
}

export interface CycleStepView {
	dataOrigin: string
	name: string
	timestamp: string
	totalSavings: number
	biogenic: number
	fossil: number
	unit: string
}

export interface Cycle {
	cycle: string
	cycleNumber: number
	plant: string
	status: CycleStatus
	serialNumber?: string
	transactionId?: string
	unit: Unit
	totalSavings: number
	biogenicSavings: number
	percentBiogenic: number
	fossilSavings: number
	percentFossil: number
	buffer: number
	assuranceTimestamp?: string
	shipmentDate: string
	co2PumpedIntoStorageDate: string
	steps?: CycleStepView[]
}

export interface CycleViewData {
	totalSavingsToBeAssured: number
	totalNewCycles: number
	totalCyclesInValidation: number
	cycles: Cycle[]
}

export interface RequestInformationDetails {
	fullName: string
	email: string
	comment: string
	buttonLink: string
}

export interface ChangeCycleStatus {
	status: CycleStatus
	serialNumber?: string
	reasonDetails?: RequestInformationDetails
}

export interface TotalDeposits {
	sum: number
}
